import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; //is this needed here.  can we/should we export from the app module?
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ControlModule } from '@Work/Accounts/proprietary/controls/control.module';
import { DirectiveModule } from '@Shared/Directives/proprietary/directive.module';
import { DynamicComponentsMap } from '@Work/Accounts/proprietary/dynamic-content-outlet/dynamic-components-map';
import { EntitySearchDialogModule } from '../../dialogs/entity-search-dialog.module';
import { InputControlModule } from '../input-control.module';
import { RichEditModule } from '../rich-edit/rich-edit.module';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { EditStatusInnerComponent } from './edit-status/edit-status-inner.component';
import { EditStatusComponent } from './edit-status/edit-status.component';
import { FieldBlockComponent } from './field-block/field-block.component';
import { FieldGroupComponent } from './field-group/field-group.component';
import { FieldSectionComponent } from './field-section/field-section.component';
import { FieldInnerComponent } from './field/field-inner.component';
import { FieldComponent } from './field/field.component';
import { LocationSelectorComponent } from './location-selector/location-selector.component';
import { SubLocationSelectorComponent } from './location-selector/sub-location-selector.component';
import { RadioGroupComponent } from './radiogroup/radiogroup.component';
import { SubPanelComponent } from './sub-panel/sub-panel.component';
import { UXContainerComponent } from './ux-container/ux-container.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DirectiveModule,
        ReactiveFormsModule,
        EntitySearchDialogModule,
        InputControlModule,
        ControlModule,
        NgbTooltipModule,
        RichEditModule
    ],
    declarations: [
        CheckboxComponent,
        SubPanelComponent,
        RadioGroupComponent,
        EditStatusComponent,
        EditStatusInnerComponent,
        LocationSelectorComponent,
        SubLocationSelectorComponent,
        FieldComponent,
        FieldInnerComponent,
        FieldGroupComponent,
        FieldSectionComponent,
        FieldBlockComponent,
        UXContainerComponent
    ],
    exports: [
        CheckboxComponent,
        RadioGroupComponent,
        SubPanelComponent,
        EditStatusComponent,
        EditStatusInnerComponent,
        LocationSelectorComponent,
        SubLocationSelectorComponent,
        FieldComponent,
        FieldInnerComponent,
        FieldGroupComponent,
        FieldSectionComponent,
        FieldBlockComponent,
        UXContainerComponent,
        DirectiveModule,
        RichEditModule
    ]
})
export class FormControlModule {
    static dynamicComponentsMap: DynamicComponentsMap = {
        EditStatusComponent,
    };
}
